/* BuyMyBricks product cards: Add to basket and Quick buy, on every page that renders a card.
   One handler for the whole site (the live theme had this written three times, with the
   selector list broken by the June comma sweep so none of them matched).
   Add to basket posts to /cart/add.js and goes to the basket; Quick buy goes to checkout. */
(function () {
  function post(vid) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add], [data-buy]');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.dataset.add || btn.dataset.buy, was = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding';
    post(vid).then(function () {
      btn.textContent = 'Added';
      window.location.href = btn.dataset.buy ? '/checkout' : '/cart';
    }).catch(function () { btn.disabled = false; btn.textContent = was; });
  });
})();
